'use client';

import { useParams } from 'next/navigation';

import {
  DEFAULT_LOCALE,
  languagesConfig,
  languagesConfigByLocale,
  TLanguagesConfigItem,
  TLocale,
} from '@northladder/utilities';

type TUseI18nReturnType = {
  /**
   * The active language currently displayed by the UI.
   */
  activeLanguage: TLanguagesConfigItem;
  /**
   * Presents the list of all supported languages.
   */
  languagesConfig: TLanguagesConfigItem[];
  /**
   * The locale as fetched from the route path
   */
  locale: TLocale;
};

/**
 * This provides re-usable logic for the `locale` and language config.
 * It retrieves the current locale from the `next router` path locale options
 * and uses it to determine the direction of the layout and active language.
 */
export const useI18n = (): TUseI18nReturnType => {
  const locale = (useParams()?.locale || DEFAULT_LOCALE) as TLocale;
  const activeLanguage = languagesConfigByLocale[locale];

  return {
    activeLanguage,
    languagesConfig,
    locale,
  };
};
